// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EmailVerificationRejectedInfo_reason__2tTRd{margin-top:8px}.EmailVerificationRejectedInfo_link__1_wuU{margin-top:8px;padding:0 !important;height:auto !important;min-height:auto !important;line-height:inherit !important}", ""]);
// Exports
exports.locals = {
	"reason": "EmailVerificationRejectedInfo_reason__2tTRd",
	"link": "EmailVerificationRejectedInfo_link__1_wuU"
};
module.exports = exports;
